<template>
  <div>
    <Head title="Perfil" />
    <div class="shadow_box rounded-lg p-6">
        <h1 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">Perfil</h1>

        <form @submit.prevent="update">
            <div class="flex flex-wrap mb-4 px-4">
                <file-input v-if="user.role == 2" v-model="form.professional.image" :error="form.errors['professional.image']" class="pb-8 w-full lg:w-1/2" label="Imagem de perfil" />

                <text-input v-model="form.name" :error="form.errors.name" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="Nome" />
                <mask-input v-model="form.cpf" mask="###.###.###-##" :error="form.errors.cpf" class="pb-8 w-full lg:w-1/2" label="CPF" />

                <select-input v-if="user.role == 2" v-model="form.professional.class_entity" :error="form.errors[`professional.class_entity`]" class="pb-8 lg:pr-6 w-full lg:w-1/3" label="Conselho profissional">
                  <option :value="null" />
                  <option v-for="(value, name, index) in class_entity_options" :key="name" :value="name">{{ value }}</option>
                </select-input>
                <text-input v-if="user.role == 2" v-model="form.professional.class_number" :error="form.errors[`professional.class_number`]" class="pb-8 lg:pr-6 w-full lg:w-1/3" label="Número do órgão" />
                <select-input v-if="user.role == 2" v-model="form.professional.uf" :error="form.errors[`professional.uf`]" class="pb-8 w-full lg:w-1/3" label="UF">
                  <option :value="null" />
                  <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
                </select-input>

                <text-input v-model="form.email" :error="form.errors.email" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="E-mail" />
                <password-input v-model="form.password" :error="form.errors.password" class="pb-8 w-full lg:w-1/2" label="Senha" />
            </div>
            <div class="">
                <loading-button :loading="form.processing" class="btn-blue" type="submit">Salvar</loading-button>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import MaskInput from '@/Shared/MaskInput'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    LoadingButton,
    SelectInput,
    TextInput,
    PasswordInput,
    MaskInput,
    FileInput,
  },
  props: {
    profile: Object,
    states_options: Object,
    class_entity_options: Object,
  },
  remember: 'form',
  data() {
    return {
      form: useForm({
        name: this.profile.name,
        cpf: this.profile.cpf,
        email: this.profile.email,
        password: '',
        professional: this.profile.professional,
      }),
    }
  },
  layout: Layout,
  methods: {
    update() {
      this.form.post(`/profile`, {
        forceFormData: true,
      })
      /*
      this.form.put(`/profile`, {
        preserveState: true,
      })
      */
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
}
</script>
